import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { ARCHIVE_MODAL } from "@/constants/campaignLifecycle";
import CampaignActionDialog from "./CampaignActionDialog";

interface ArchiveCampaignModalProps {
  open: boolean;
  campaignName: string;
  /** A canceled campaign reads "was canceled"; anything else "has already gone out". */
  wasCanceled: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** Confirm archiving a finished campaign — hidden from the default list, restorable via the filter. */
export default function ArchiveCampaignModal({
  open,
  campaignName,
  wasCanceled,
  onClose,
  onConfirm,
}: ArchiveCampaignModalProps) {
  return (
    <CampaignActionDialog
      open={open}
      title={ARCHIVE_MODAL.title}
      icon={Inventory2OutlinedIcon}
      body={ARCHIVE_MODAL.body(campaignName, wasCanceled)}
      primaryLabel={ARCHIVE_MODAL.confirm}
      secondaryLabel={ARCHIVE_MODAL.dismiss}
      onPrimary={onConfirm}
      onClose={onClose}
    />
  );
}
